// Spanish translation

const es = {
  "menu.party": "CLIENTES",
  "party.party": "Clientes",
  "party.party.name": "Nombre",
  "party.party.id_number": "Número de Identificación",
  "party.party.nationality": "Nacionalidad",
  "party.party.sex": "Sexo",
  "party.party.main_mobile": "Teléfono Móvil",
  "party.party.main_email": "Correo Electrónico",
  "party.party.street": "Calle",
  "party.party.subdivision": "Subdivisión",
  "party.party.country": "País",
  "party.party.city": "Ciudad",
  "party.party.type_document": "Tipo de Documento",
  "party.party.type_person": "Tipo de Persona",
  "party.party.birthday": "Fecha de Nacimiento",
  "tryton.id_number_already_exists": "El número de identificación ya existe",
  "invoice_report.party_dunning": "Reporte Detallado de Cartera",
  "party.party.validation.invalid_name": "El nombre es inválido",
  "party.party.validation.invalid_email": "Formato de correo inválido",
  "party.party.validation.invalid_phone":
    "El teléfono debe tener entre 7 y 15 dígitos",
  "party.party.validation.invalid_IdNumber":
    "El número de identificación es inválido",
  "party.party.validation.invalid_date": "Formato de fecha inválido",
  "party.party.validation.client_dian": "No se encontro registro en la DIAN",
};

export default es;
